export default __webpack_public_path__ + "static/media/nightinfield.d0f99a72.jpg";